import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import {
  CreditCardOutlined,
  HomeOutlined,
  InsertRowAboveOutlined,
} from "@ant-design/icons";
import { Images, Services } from "../../../Controller";
import {
  BiBulb,
  BiBus,
  BiCylinder,
  BiDish,
  BiDroplet,
  BiHotel,
  BiRefresh,
  BiWater,
  BiWifi,
} from "react-icons/bi";
import { PortalName, serviceCategory, trimString } from "../../../Utils";
import { AiFillCheckCircle, AiOutlineUser } from "react-icons/ai";
import { TbDroplet, TbMoneybag } from "react-icons/tb";
import { ThemeColor } from "../../../Theme/theme";
import { FcCancel } from "react-icons/fc";
import {
  GetDashboardData,
  GetWalletBalance,
} from "../../../ApiServices/Apifun";
import {
  BsArrowDown,
  BsArrowLeft,
  BsArrowUp,
  BsChevronRight,
} from "react-icons/bs";
import { Breadcrumb, Carousel, Collapse, Skeleton, Spin, Tooltip } from "antd";
import { MdCable, MdCancel, MdFlight, MdPending } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { Gas_Icon } from "../../../Assets/gas_icon";
import { Electricity } from "../../../Assets/Electricity";
import { Water } from "../../../Assets/water_icon";
import { Cable } from "../../../Assets/cable";
import { Fasttag } from "../../../Assets/fastag";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cardData, setCardData] = useState({
    Total_txn: "",
    money_in: "",
    money_out: "",
    members: "",
  });
  const [spinState, setSpinState] = useState(false);
  const [collapsed, setCollapsed] = useState(["0"]);
  const [loader, setLoader] = useState(false);
  const [activeServices, setActiveServices] = useState([]);
  const [banners, setBanners] = useState([]);
  const [inActiveServices, setInactiveServices] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const walletBalance = useSelector((state) => state.B2B.walletBal);
  const heading = useSelector((state) => state.B2B.heading);
  const memberService = useSelector((state) => state.B2B.memberServices);
  const [Balance, setBalance] = useState(null);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);

  useEffect(() => {
    dispatch(setselectedTab("1"));
    let active = [];
    let inactive = [];
    Object.entries(serviceCategory).map(([key, val]) => {
      if (memberService.includes(val)) {
        active = [...active, key];
      } else {
        inactive = [...inactive, key];
      }
    });
    setActiveServices(active);
    setInactiveServices(inactive);
    setBalance(walletBalance);
  }, [memberService, walletBalance]);

  const getDashboard = () => {
    setLoader(true);
    GetDashboardData()
      .then((res) => {
        setBanners(res.banners);
        setAccordionData(
          res.services.map((i, index) => {
            return {
              key: index,
              label: (
                <div className="grid grid-cols-3 w-full gap-2 place-items-start">
                  <img
                    src={i.icon}
                    className="w-10 h-10 bg-white  p-1 rounded-full"
                    alt="icon"
                  />
                  <div className="text-xs col-span-2 font-medium w-full">
                    <p>{i.service_name}</p>
                    <p>Total amt: {i.total_amount} Rs.</p>
                  </div>
                </div>
              ),
              children: (
                <div className=" text-xs font-bold leading-5">
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Success</p>
                    <p className="">
                      {i.total_transactions_success} (
                      {"₹" + " " + i.total_amount_success})
                    </p>
                    <AiFillCheckCircle
                      className="bg-white  shadow-black text-green-700"
                      size={25}
                    />
                  </div>
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Pending</p>
                    <p className="">
                      {i.total_transactions_pending} (
                      {"₹" + " " + i.total_amount_pending})
                    </p>
                    <MdPending
                      className="bg-white  shadow-black text-yellow-700"
                      size={25}
                    />
                  </div>
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Failed</p>
                    <p className="">
                      {i.total_transactions_failed} (
                      {"₹" + " " + i.total_amount_failed})
                    </p>
                    <MdCancel
                      className="bg-white  shadow-black text-red-700"
                      size={25}
                    />
                  </div>
                </div>
              ),
              // showArrow: false,
            };
          })
        );
        setCardData({
          Total_txn: res.total_transactions,
          money_in: res.money_in,
          money_out: res.money_out,
          members: res.total_members,
        });
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    getDashboard();
  }, []);
  useEffect(() => {}, [collapsed]);
  const handleGet = () => {
    setSpinState(true);
    GetWalletBalance()
      .then((res) => {
        setBalance(res.balance);
        setSpinState(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="mb-5 p-2 bg-white rounded-md font-semibold shadow-[0px_2px_2px_#ccdcff] w-full flex justify-between items-center gap-4">
        <BsArrowLeft
          size={15}
          color={ThemeColor.primary}
          onClick={() => navigate(-1)}
          className="cursor-pointer"
        />
        <div className=" rounded-sm w-full flex text-rgbaprimary7 justify-between">
          {" "}
          <p className="py-1  rounded-md font-bold  text-[21px]">{heading}</p>
          <div className="py-1">
            <Breadcrumb
              items={[
                {
                  title: (
                    <p className="text-black font-medium">
                      <HomeOutlined /> Home
                    </p>
                  ),
                },
                {
                  title: (
                    <p className="text-rgbaprimary7 font-semibold">{heading}</p>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl  grid grid-cols-1 lg:grid-cols-2 place-items-center">
        <div className="bg-white  rounded-xl  grid grid-cols-1 lg:grid-cols-3 gap-2 place-items-start">
          {" "}
          {[
            {
              label: "Current month Business",
              icon: <BiBus />,
              color: "#fffff",
            },
            {
              label: "Previous month Business",
              icon: <MdFlight />,
              color: "#fffff",
            },
            {
              label: "Quarterly month Business",
              icon: <BiHotel />,
              color: "#fffff",
            },
            {
              label: "Success Transaction",
              icon: <BiHotel />,
              color: "#d6ffd8",
            },
            {
              label: "Failed Transaction",
              icon: <BiHotel />,
              color: "#ffe3e7",
            },
            {
              label: "Pending Transaction",
              icon: <BiHotel />,
              color: "#f9d1b4",
            },
          ].map((i, id) => {
            return (
              <div
                onClick={() => navigate(i.path)}
                style={{ backgroundColor: i.color }}
                className=" h-[80px] p-3 cursor-pointer relative animate-fade-in w-[170px] rounded  shadow-sm shadow-[#5e72e4]"
              >
                <div className="text-black  text-xs items-center">
                  {i.label}
                </div>

                <p className="text-black text-sm mt-6">₹0.00</p>
              </div>
            );
          })}
        </div>
        <div
          className="w-full md:h-48 bg-cover bg-center  rounded-xl mt-2 p-1"
          style={{ backgroundImage: `url(${Images.bg})` }}
        >
          <div className="  rounded-xl  gap-4 place-items-start m-2 p-2">
            {" "}
            <p className="font-semibold text-white text-xl border-b-2  border-gray-400">
              Welcome U7Pay FastTag
            </p>
            {/* <p className="font-semibold text-white text-xl border-b-2  border-gray-400">
              DEMO Travel
            </p> */}
            <div className=" text-white text-sm border-b-2 border-gray-400 grid grid-cols-3 mt-6">
              <p className=" text-white  border-gray-400">
                {profiledetail?.first_name}
                {profiledetail?.last_name}
              </p>{" "}
              <p className=" text-white  border-gray-400">
                {profiledetail?.mobile}
              </p>{" "}
              <p className=" text-white  border-gray-400">
                {profiledetail?.email}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-300 rounded-xl grid grid-cols-1 md:grid-cols-3 gap-2 place-items-start">
          {" "}
          <div
            onClick={() => navigate(i.path)}
            className=" h-[250px] p-8 cursor-pointer relative animate-fade-in  rounded text-center items-center  "
          >
            <div className="text-white  text-xl ">Welcome to FastTag</div>

            <p className="text-white text-xl"></p>
          </div>
        </div>
        <div className="bg-white rounded-xl mt-2  gap-2">
          {" "}
          {[
            {
              label: "Fastag",
              icon: <Fasttag />,
              color: "#d6ffd8",
              path: "/bbps?service=Fastag",
            },
          ].map((i, id) => {
            return (
              <div
                onClick={() => navigate(i.path)}
                style={{ backgroundColor: i.color }}
                className=" lg:h-[250px]  lg:w-[570px] p-8 cursor-pointer relative animate-fade-in  rounded-xl text-center items-center  "
              >
                <p className="text-rgbaprimary8 font-semibold text-3xl mb-10">
                  {i.label}
                </p>
                <div className="text-rgbaprimary8  font-bold flex justify-center">
                  {i.icon}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
